




















































import moment from "moment";
import { storePasien } from "@/store/modules/pasien";
import DataSKDP from "@/services/DataSKDP";
import { userModule } from "@/store/modules/user";
import MasterReferensi from "@/store/modules/new/MasterReferensi";

export default {
  name: "TglKontrolSkdp",
  props: {
    value: {
      type: String,
      require: true,
      default: null
    }
  },
  data() {
    return {
      tglShowKontrol: false,
      maxKontrol: new Date(new Date().setDate(new Date().getDate() + 90))
        .toISOString()
        .substr(0, 10),

      functionEvents: null,
      loadingTglKontrol: false,
      hintTglKontrol: null,
      tglrekom: "",
      dateNow: moment().format("YYYY-MM-DD")
    };
  },
  methods: {
    selectedTglKontrol() {
      this.loadingTglKontrol = true;
      this.hintTglKontrol = "";

      // pemanggilan service via nexttick agar tgl kontrol dari parent bisa di capture
      this.$nextTick(function() {
        DataSKDP.getDataKontrolSkdpAlert(
          this.tglKontrol,
          userModule.user.unit_id,
          userModule.user.id
        )
          .then(data => {
            const dt = data["data"];

            if (dt.kuota && dt.skdp_total >= dt.kuota) {
              this.hintTglKontrol = `Total SKDP yang terbuat untuk kontrol di tanggal ini sudah mencapai ${dt.skdp_total} buah`;
            }
          })
          .finally(() => {
            this.loadingTglKontrol = false;
          });
      });
    },
    getRecomendationKontrol() {
      //test
      if (userModule.user.unit_group_id == "27") {
        this.functionEvents = this.getRecomDate();
      }

      // this.tglKontrol = this.tglrekom;
      // this.tglKontrol = "2021-10";
      // console.log(this.tglrekom);
    },
    getRecomDate() {
      const pasienRegHF = this.pasien.is_reg_heart_failure;
      const now = new Date(this.dateNow);
      // const now = new Date();
      let markDayTs = new Date(new Date().setDate(now.getDate() + 30));
      let tambahanHari = 0;
      console.log("markDayTs init: " + markDayTs);

      // jika pasien reg hf pastikan tgl kontrol antara hari senin, rabu, jumat. dengan asumsi tgl mundur
      if (pasienRegHF) {
        if (![1, 3, 5].includes(markDayTs.getDay())) {
          tambahanHari = 1;
          markDayTs = new Date(
            new Date().setDate(now.getDate() + 30 + tambahanHari)
          );
        }
        console.log("markDayTs reghf: " + markDayTs);
      }

      // jika ketemu hari minggu maka mundurkan tgl rekomen ke hari senin
      if (new Date(markDayTs).getDay() === 0) {
        tambahanHari += tambahanHari;
        markDayTs = new Date(
          new Date().setDate(now.getDate() + 30 + tambahanHari)
        );
      }

      return [
        moment(new Date(markDayTs.setDate(markDayTs.getDate()))).format(
          "YYYY-MM-DD"
        )
      ];
    },
    allowedDates(val) {
      const sunday = ![0].includes(new Date(val).getDay()),
        holidays = !this.holidays.includes(val);

      return sunday && holidays;
    }
  },
  computed: {
    tglKontrolFormattedMomentjs() {
      return this.tglKontrol
        ? moment(this.tglKontrol).format("DD MMMM YYYY")
        : "";
    },
    pasien() {
      return storePasien.identitasPasien;
    },
    tglKontrol: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit("setValue", val);
      }
    },
    holidays() {
      return MasterReferensi.holidays.map(item => item.date);
    }
  }
};
